// Stand-in page for console sections that haven't been built yet.
type Props = { title: string; blurb: string };

export function Placeholder({ title, blurb }: Props) {
  return (
    <div className="page">
      <div className="page-head">
        <h1>{title}</h1>
        <p>{blurb}</p>
      </div>
      <div className="card muted">Coming soon.</div>
    </div>
  );
}
